module.exports = __webpack_public_path__ + "static/media/brady_small.6465048a.png";